import {Route} from 'react-router'
import {RecordsRoute} from '~/routing/components/records_route'
import {
	EditOrganisation,
	EditEnvironment,
	Environments,
	ExportUsers,
	ImportUsers,
	MigrateEnvironment,
	NewEnvironment,
	Organisations,
	ShowUser,
	SplitOrganisation,
} from './index'

export const routes = (
	<>
		<Route path="/firms">
			<Route element={<RecordsRoute awaitRecords={['environments', 'organisations', 'billingActivities']} />}>
				<Route path="organisations" element={<Organisations />} />
				<Route path="organisations/:id/edit" element={<EditOrganisation />} />
				<Route path="organisations/split" element={<SplitOrganisation />} />
				<Route path="environments" element={<Environments />} />
				<Route path="environments/new" element={<NewEnvironment />} />
				<Route path="environments/:id/edit" element={<EditEnvironment />} />
				<Route path="environments/:id/migrate" element={<MigrateEnvironment />} />
			</Route>
		</Route>
		<Route path="/users">
			<Route element={<RecordsRoute awaitRecords={['organisations', 'environments']} />}>
				<Route path="import" element={<ImportUsers />} />
				<Route path=":id" element={<ShowUser />} />
			</Route>
			<Route path="export" element={<ExportUsers />} />
		</Route>
	</>
)
